module.exports = __webpack_public_path__ + "media/images/new_home/white_Plus_Circle-d2cc8a0f58b9d75fd860043a2a918667.png";